import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import type { SelectedEntity } from '@common/types/layout.type';

import type { NormalizedSectionEntity, NormalizedColumnEntity } from '@web/types';

import { ColumnsFacade } from '@web/store/page-structure/columns/columns.facade';

import { NavigationZeroColumnItemComponent } from '../navigation-zero-column-item';

@Component({
    selector: 'web-navigation-zero-section-item',
    templateUrl: './navigation-zero-section-item.component.html',
    styleUrls: ['./navigation-zero-section-item.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NavigationZeroColumnItemComponent],
})
export class NavigationZeroSectionItemComponent {
    public readonly entity = input.required<NormalizedSectionEntity>();
    public readonly index = input.required<number>();
    public readonly selectedEntity = input.required<SelectedEntity>();

    private readonly columnsFacade: ColumnsFacade = inject(ColumnsFacade);

    private readonly columnsEntities = toSignal(this.columnsFacade.columnsEntities$, { initialValue: {} });

    public readonly columns = computed(() => {
        const columns = this.columnsEntities();
        return this.entity().children.map((columnId) => columns[columnId] as NormalizedColumnEntity);
    });
}
